<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { MoonIcon, Sun2Icon } from '@solar-icons/vue/linear'
import AppButton from '../../primitives/AppButton/AppButton.vue'
import AppTooltip from '../../primitives/AppTooltip/AppTooltip.vue'

const props = defineProps<{
  /** The theme on screen now. */
  theme: 'light' | 'dark'
}>()

const emit = defineEmits<{
  'update:theme': [value: 'light' | 'dark']
}>()

const { t } = useI18n()
const isDark = computed(() => props.theme === 'dark')
</script>

<template>
  <AppTooltip :content="t('shell.darkTheme')" placement="right">
    <template #trigger="{ aria }">
      <AppButton
        size="sm"
        variant="ghost-strong"
        icon-only
        :start-icon="isDark ? MoonIcon : Sun2Icon"
        role="switch"
        :aria-checked="isDark"
        :aria-label="t('shell.darkTheme')"
        v-bind="aria"
        @click="emit('update:theme', isDark ? 'light' : 'dark')"
      />
    </template>
  </AppTooltip>
</template>
